export default __webpack_public_path__ + "static/media/4 in 1 - active.948ec02f.svg";